var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticStyle:{"background-color":"#F6F9F9"}},[_c('global-header'),_c('div',{staticClass:"basic-height"},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }